const COOKIE_NAMES = {
    KLARNA_PAYMENT_CLIENT_TOKEN: 'payment-session-token',
};

export default COOKIE_NAMES;
